import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import { translate } from 'react-i18next';

import App from 'components/App.js';
import Popover from 'components/popover/Popover.js';

class HeaderBar extends React.Component {
  constructor(props) {
    super(props);

    this._onUserMenuToggle = this._onUserMenuToggle.bind(this);
    this._onSignOutClicked = this._onSignOutClicked.bind(this);
    this._onAccountClicked = this._onAccountClicked.bind(this);
    this._onTimeSheetsClicked = this._onTimeSheetsClicked.bind(this);
    this._onNavSelected = this._onNavSelected.bind(this);
    this._handlePopoverClose = this._handlePopoverClose.bind(this);
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this._onWorkspaceUpdated = this._onWorkspaceUpdated.bind(this);

    const theme = Utils.getTheme();

    this.state = {
      activeButton: this.props.currentLocation,
      popOverActive: false,
      popTarget: null,
      themeIconUrl: theme && theme.icon_url && theme.icon_url.dark,
    };

    this.previousActiveState = null;
  }

  componentDidMount() {
    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
    WorkspaceStore.on('workspace:lookup:success', this._onWorkspaceUpdated, this);
    WorkspaceStore.on('workspace:config:cleared', this._onWorkspaceUpdated, this);
  }

  componentWillUnmount() {
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
    WorkspaceStore.off(null, null, this);
  }

  _onWorkspaceUpdated() {
    Utils.applyWorkspaceTheme();
    const theme = Utils.getTheme();
    this.setState({
      themeIconUrl: theme && theme.icon_url && theme.icon_url.dark,
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.currentLocation != this.props.currentLocation) {
      this.setState({
        activeButton: this.props.currentLocation,
      });
    }
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _onClosePopover(e) {
    this._handlePopoverClose();
  }

  _handlePopoverClose() {
    let properState = 'user-nav';
    if (Utils.getInitialLocation() != '/account' && Utils.getInitialLocation() != '/timesheets') {
      properState = this.previousActiveState;
    }
    this.setState({
      activeButton: properState,
      popOverActive: false,
      popTarget: null,
    });
  }

  _closeAccountMenu() {
    this.setState({
      popOverActive: !this.state.popOverActive,
      popTarget: ReactDOM.findDOMNode(this).querySelector('#schedule-button'),
    });
  }

  _onUserMenuToggle() {
    if (this.state.activeButton != 'user-nav') {
      this.previousActiveState = this.state.activeButton;
    }
    this.setState({
      activeButton: 'user-nav',
    });
    this._closeAccountMenu();
  }

  _onSignOutClicked() {
    Utils.signOut();
    Utils.removeSpinner();
    this._onClosePopover();
  }

  _onNavSelected() {
    this.setState({
      activeButton: 'schedule',
    });
    Utils.removeSpinner();
  }

  _onAccountClicked() {
    Utils.getBrowserHistory().push('/account');
    Utils.removeSpinner();
    this._onClosePopover();
  }

  _onTimeSheetsClicked(e) {
    Utils.getBrowserHistory().push('/timesheets');
    this._onClosePopover();
  }

  renderTimesheetLink() {
    const coreUser = Utils.getCoreUser();
    const companySettings = coreUser && coreUser.company;
    const renderTimesheetLink = companySettings && companySettings.time_and_attendance_without_personal_clock;

    return renderTimesheetLink && (
      <li onClick={this._onTimeSheetsClicked}>
        <a href="#" id="timesheet-button">
          {this.props.t('HeaderBar.timesheet')}
        </a>
      </li>
    );
  }

  render() {
    const userName = !Utils.isNotDefined(this.props.userName)
      ? this.props.userName
      : this.props.t('HeaderBar.user');
    return (
      <header>
        <div id="header-container">
          <Link
            to={{
              pathname: '/schedule',
              params: { app: App, title: `${this.props.t('HeaderBar.login')} - MakeShift Web Employee` },
            }}
            onClick={this._onNavSelected}
            id="logo-wordmark"
            activeClassName="active"
            className={this.state.themeIconUrl ? undefined : 'svgs-makeshift-logo'}
          >
            {this.state.themeIconUrl
              ? <img src={this.state.themeIconUrl} alt="Logo" style={{ height: '30px' }} />
              : 'MakeShift'
            }
          </Link>
          <nav>
            <Link
              to={{ pathname: '/schedule', params: { title: `${this.props.t('HeaderBar.schedule')} - MakeShift Web Employee` } }}
              id="schedule-button"
              onClick={this._onNavSelected}
              activeClassName="active"
              className={this.state.activeButton == 'schedule' ? 'active' : null}
            >
              <i className="icon-nav-calendar" />
              {this.props.t('HeaderBar.schedule')}
            </Link>
            <a
              href="javascript:void(0)"
              id="user-button"
              onClick={this._onUserMenuToggle}
              className={this.state.activeButton == 'user-nav' ? 'active' : null}
            >
              <i className="icon-nav-account" />
              {userName}
            </a>
          </nav>
        </div>
        <div className="account-menu-container">
          <Popover
            position="top"
            className="account-menu"
            onHide={this._handlePopoverClose.bind(this)}
            active={this.state.popOverActive}
            popTarget={this.state.popTarget}
          >
            <ul>
              <li onClick={this._onAccountClicked}>
                <a href="#" id="account-button">
                  {this.props.t('HeaderBar.account')}
                </a>
              </li>
              {this.renderTimesheetLink()}
              {window.EmployeeWeb.ENVConfig.menu_support_link && (
                <li>
                  <a href={window.EmployeeWeb.ENVConfig.menu_support_link} target="_blank" rel="noopener noreferrer">
                    {this.props.t('HeaderBar.support')}
                  </a>
                </li>
              )}
              <li onClick={this._onSignOutClicked}>
                <a href="#" id="signout-button">
                  {this.props.t('HeaderBar.sign_out')}
                </a>
              </li>
            </ul>
          </Popover>
        </div>
      </header>
    );
  }
}

export default translate()(HeaderBar);
